import { getConfig } from '../../../utils/LoadingData';

export default getConfig();
